// extracted by mini-css-extract-plugin
export default {"round_checkbox":"style_round_checkbox__IQrqO","checked":"style_checked__aP20F","inner_circle":"style_inner_circle__t3cgs"};